import z from 'zod';

export const promoCodeSchema = z.object({
  discount: z.coerce.number().min(1, 'Min 1%').max(100, 'Max 100%'),
});

export const promoEmailSchema = z.object({
  email: z.string().email('Invalid email address'),
});
